import type { BreadcrumbsCategory } from "~/types/composables/useCategoryTypes";
import { toBreadcrumbChain } from "~/utils/categories/toBreadcrumbChain";

/**
 * Resolves a product's primary Norce category (`product.CategoryId`) into the
 * parent-linked shape `pageStore.categoryBreadcrumb` expects, so the PDP can
 * show Home / Category / … / Product instead of a flat Home / Product.
 */
export const useProductCategoryBreadcrumb = () => {
	const { fetchCategoryTree } = useFetchCategoryTree();
	const { getCategoryDetailsById } = useCategory();

	const resolveProductCategoryBreadcrumb = async (
		categoryId: number | null | undefined,
		locale: string
	): Promise<BreadcrumbsCategory | null> => {
		if (!categoryId) return null;

		try {
			const categoryTree = await fetchCategoryTree(locale);
			const category = getCategoryDetailsById(
				categoryTree,
				categoryId,
				"CategoryId"
			);
			return category?.Name ? toBreadcrumbChain(category) : null;
		} catch (error) {
			// Breadcrumbs are secondary — never fail the product page over them.
			console.error("Error resolving product category breadcrumb:", error);
			return null;
		}
	};

	return { resolveProductCategoryBreadcrumb };
};
